import { render, staticRenderFns } from "./AutobuyerSingleToggleLabel.vue?vue&type=template&id=311f081c&scoped=true&"
import script from "./AutobuyerSingleToggleLabel.vue?vue&type=script&lang=js&"
export * from "./AutobuyerSingleToggleLabel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "311f081c",
  null
  
)

export default component.exports